// Libraries imports
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

// Assets and theme imports
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete1.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { THEME_MODE } from "../../../constants/Theme";

import SwitchInput from "../../../components/SwitchInput";

const table_header_list = ["Name", "Printer Type", "IP Address/Path", "Port", "Copies", "Display Name", "Assigned Courses", "Linked Floors", "Receipt", "Online Receipt", "Active"];

const PrintersList = ({ themeMode, itemList, onEditClick, onDeleteClick, coursesList, floorList, activePrinter, toggleActivePrinter, addPrinterHandler }) => {
    const theme_mode = THEME_MODE[themeMode ?? "light"];
    const styles = componentStyles(theme_mode);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontFamily: "GilroySemiBold",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            fontFamily: "GilroyMedium",
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        "&:last-child td, &:last-child th": {
            border: 0,
        },
    }));

    return (
        <TableContainer component={Paper}>
            {itemList.length ? (<Grid container direction="row" >
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {table_header_list.map((x, i) => {
                                    return (
                                        <StyledTableCell key={i}>
                                            <Box>{x}</Box>
                                        </StyledTableCell>
                                    );
                                })}
                                <StyledTableCell></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        {itemList.length ?
                            <TableBody>
                                {itemList.map((item, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell>{item.name}</StyledTableCell>
                                        <StyledTableCell>{item.isUsbPrinter ? "USB" : "Ethernet"}</StyledTableCell>
                                        <StyledTableCell>{item.IPAddress}</StyledTableCell>
                                        <StyledTableCell>{item.isUsbPrinter ? "N/A" : item.portNumber}</StyledTableCell>
                                        <StyledTableCell>{item.noOfCopies || 1}</StyledTableCell>
                                        <StyledTableCell>{item.displayName}</StyledTableCell>
                                        <StyledTableCell>
                                            {coursesList
                                                ?.filter((x) => item?._idCourses?.includes(x?._id))
                                                .map((x) => x?.name)
                                                .join(", ")}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {floorList
                                                ?.filter((x) => item?._idFloors?.includes(x?._id))
                                                .map((x) => x?.name)
                                                .join(", ") || "None"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {item.receiptEnabled ? "Yes" : "No"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {item.isOnlineOrderReceiptsEnabled ? "Yes" : "No"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <SwitchInput
                                                checked={item.isActive}
                                                onChange={() => toggleActivePrinter(item)}
                                                inputProps={{ "aria-label": "ant design" }}
                                                themeMode={themeMode}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Box
                                                sx={{
                                                    ...styles.actionBox,
                                                    path: {
                                                        stroke: theme_mode.iconBg2,
                                                    },
                                                }}
                                                pr={2}
                                            >
                                                <EditIcon
                                                    height={24}
                                                    width={24}
                                                    style={{ cursor: "pointer", strokeWidth: '0.1px' }}
                                                    onClick={() => onEditClick(item)}
                                                />
                                                <DeleteIcon
                                                    height={24}
                                                    width={24}
                                                    style={{ marginLeft: 14, cursor: "pointer" }}
                                                    onClick={() => onDeleteClick(item)}
                                                />
                                            </Box>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                            : <Card sx={styles.noPrinterContainer}>
                                <h3>No Printer Added</h3>
                                <Button onClick={addPrinterHandler}
                                    sx={{ backgroundColor: 'black', color: 'white', px: 1, '&:hover': { backgroundColor: 'black' } }}>
                                    Add a Printer
                                </Button>
                            </Card>
                        }
                    </Table>
                </TableContainer>
            </Grid>) : null}
        </TableContainer>
    );
};

export default PrintersList;

const componentStyles = (Theme) => ({
    nameBox: {
        minWidth: 110,
    },
    actionBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        path: {
            stroke: Theme.iconBg2,
        },
    },
    noPrinterContainer: {
        width: '100%',
    }
});